import { AbstractDataResource, AxiosResponseExt } from '@/api/resources'
import { AxiosInstance, CancelTokenSource } from 'axios'
import ProductModel from '@/api/model/product'
import HoraireModel from '../../../../frontend/src/api/model/horaire'

export default class ProductResource extends AbstractDataResource<ProductModel> {
  constructor (axios: AxiosInstance) {
    super(axios, 'product')
  }

  // product (id: number, cancelTokenSource?: CancelTokenSource): Promise<ProductModel> {
  //   //   let cancelOptions = cancelTokenSource ? { cancelToken: cancelTokenSource.token } : undefined
  //   //   let promise = this.wrapPromise(this.axios.post(`/api/product/${id}`, cancelOptions))
  //   //   return promise as Promise<ProductModel>
  //   // }

  products (cancelTokenSource?: CancelTokenSource): Promise<ProductModel[]> {
    let cancelOptions = cancelTokenSource ? { cancelToken: cancelTokenSource.token } : undefined
    let promise = this.wrapPromise(this.axios.get(`/api/produits`, cancelOptions))
    return promise as Promise<ProductModel[]>
  }

  productsTag (id: number, cancelTokenSource?: CancelTokenSource): Promise<ProductModel[]> {
    let cancelOptions = cancelTokenSource ? { cancelToken: cancelTokenSource.token } : undefined
    let promise = this.wrapPromise(this.axios.get(`/api/produitsTag/${id}`, cancelOptions))
    return promise as Promise<ProductModel[]>
  }

  productsStock (cancelTokenSource?: CancelTokenSource): Promise<ProductModel[]> {
    let cancelOptions = cancelTokenSource ? { cancelToken: cancelTokenSource.token } : undefined
    let promise = this.wrapPromise(this.axios.get(`/api/produitsStock`, cancelOptions))
    return promise as Promise<ProductModel[]>
  }

  // updateProducts (cancelTokenSource?: CancelTokenSource): Promise<ProductModel[]> {
  //   let cancelOptions = cancelTokenSource ? { cancelToken: cancelTokenSource.token } : undefined
  //   let promise = this.wrapPromise(this.axios.get(`/api/updateProducts`, cancelOptions))
  //   return promise as Promise<ProductModel[]>
  // }
}
